const user = {
  state: {
    user_name: window.sessionStorage.getItem('user_name'),
    user_gender: Number(window.sessionStorage.getItem('user_gender'))
  },
  mutations: {
    SET_USER_NAME (state, value) {
      window.sessionStorage.setItem('user_name', value)
      state.user_name = value
    },
    SET_USER_GENDER (state, value) {
      window.sessionStorage.setItem('user_gender', value)
      state.user_gender = value
    }
  },
  actions: {}
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js